




















































































































interface departList { accountBookId: number; code: null; fullcode: null; hidden: string; id: number | string; leaf: null; name: string; no: string; pid: null; pno: null; }
interface employeeList { accountBookId: number; dimDepartmentId: null; assDepartmentName: null; code: null; fullcode: null; hidden: string; id: number | string; licenseNo: string; licenseType: string; name: string; no: string; phone: string; }
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import Employee from "./Employee";
import idTypeList from "../../data/idTypeList";
import NewAddDepartVue from "./NewAddDepart.vue";
import { ElSelect } from "element-ui/types/select";
import { ElDatePicker } from "element-ui/types/date-picker";

@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "newAdd-depart": NewAddDepartVue,
    }
})
export default class NewAddEmploy extends Vue {
    employee: Employee = new Employee();
    // 受雇类型
    employeeTypeList: DataTable.DropItem[] = [{ id: "0", text: "雇员" }, { id: "1", text: "其他" }];

    @Prop({ type: Array, default: [] })
    employeeList!: employeeList[];

    typeList = idTypeList
    departList: departList[] = [];

    showAdd: boolean = false;

    mounted() {
        this.employee.employType = "0";
        this.employee.no = <string>this.getNo();
        this.getDepartList();
    }
    // 获取部门
    getDepartList(then?: any) {
        Vue.axios
            .post(`dim/account/find`, {
                accountBookId: this.$store.state.accountBook.id,
                dimAccountType: "部门"
            })
            .then(res => {
                this.departList = res.data.dimDepartmentList;
                if (then) then()
            });
    }

    getNo() {
        let no;
        if (this.employeeList.length > 0) no = parseInt(this.employeeList[this.employeeList.length - 1].no) + 1;
        else no = 1;
        if (no < 10) {
            return "000" + String(no);
        } else if (no < 100) {
            return "00" + String(no);
        } else if (no < 1000) {
            return "0" + String(no);
        } else {
            return no
        }
    }

    toNext(index: number, ref?: string) {
        let allInput: any = this.$el.querySelectorAll("input");
        if (ref) {
            (<any>this.$refs[ref]).handleClose();
        }
        if (index < 6) allInput[index + 1].focus();
        else if (index === 6) (<ElDatePicker>this.$refs.hireDateInput).focus();
        else this.confirm();
    }

    confirm() {
        if (
            this.employee.no != "" &&
            this.employee.name != ""
        ) {
            if (this.testNo()) {
                if (this.employee.licenseType === "1") {
                    if (!this.$utils.isCorrectAge(this.employee.licenseNo)) {
                        this.$message("亲，新增员工的年龄未满18岁或大于60岁");
                    }
                    Vue.axios
                        .post(`dim/employee/add`, {
                            accountBookId: this.$store.state.accountBook.id,
                            bankAccount: "",
                            contact: "",
                            hidden: "n",
                            measureUnit: "",
                            phone: this.employee.phone,
                            licenseType: this.employee.licenseType,
                            licenseNo: this.employee.licenseNo,
                            dimDepartmentId: this.employee.dimDepartmentId,
                            name: this.employee.name,
                            employType: this.employee.employType,
                            no: this.employee.no,
                            taxNo: "",
                            startDate: this.$utils.simpleDateFormat(this.hireDate, "d")
                        })
                        .then(res => { this.$emit("addSuccess", res.data); });
                }
            } else {
                this.toNext(3);
            }
        } else {
            this.$message("亲，请将数据完整填写");
            (<any>this.$el.querySelector("input")).focus();
        }
    }
    close() {
        this.$emit("close");
    }

    departKeyDown(e: KeyboardEvent) {
        if (e.keyCode === 121) {
            this.addDepart();
        } else {
            this.toNext(5);
        }
    }
    employTypekeyDown() {
        this.toNext(6)
    }

    addDepart() {
        this.showAdd = true;
        this.$nextTick(() => {
            let addApart = (<NewAddDepartVue>this.$refs.addDepart);
            (<HTMLInputElement>addApart.$refs.nameInput).focus();
        })
    }

    addSuccess(department: departList) {
        this.showAdd = false;
        this.getDepartList(() => {
            this.$nextTick(() => {
                this.employee.dimDepartmentId = <string>department.id;
                this.$forceUpdate();
                (<ElSelect>this.$refs.departSelect).focus();
            })
        })
    }

    closeAdd() {
        this.showAdd = false;
    }

    // 添加受雇日期
    hireDate: Date = new Date();

    // 添加身份证验证
    testNo() {
        const reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
        if (this.employee.licenseType === "1") {
            if (!reg.test(this.employee.licenseNo)) {
                this.$message.warning("身份证格式不正确");
                return false;
            }
            return true;
        }
        return true;
    }

}
